import React from 'react';
import Marquee from './Marquee';
import { Label, Panel } from './styles';
import { percentFormat } from '../../Utils/NumberFormatting';
import { css } from 'emotion';

export const link = css`
	font-family: 'Barlow', sans-serif;
	color: #000;
	padding: 0 0.25rem;
`;

const getAllItems = (senateItems) => {
	const senateElectionsName = {
		name: <strong> Senátní volby - 2. kolo: </strong>
	}
	return [
		senateElectionsName,
		...senateItems
	]
};

export default (props) => {
	const getAreaName = (area) => {
		const areaName = area.name;
		const areaCount = percentFormat(area.count[props.roundIndex], 0);
		return areaName + ' - ' + 'Sečteno:' + ' ' + areaCount + ' - ';
	}

	const getFinalistNamesByArea = (area) =>
		getAreaName(area) +
		' ' +
		props.finalists
			.filter((finalist) => finalist.area.id === area.id)
			.map(
				(finalist) =>
					finalist.name +
					' ' +
					finalist.lastName +
					' ' +
					percentFormat(finalist.percent[props.roundIndex], 0)
			)
			.join(', ');

	const getSenateItems = () => props.finalists.reduce((uniqueFinalists, finalist) =>
		uniqueFinalists.find(uniqueFinalist => uniqueFinalist.area.id === finalist.area.id)
			? uniqueFinalists
			: [...uniqueFinalists, finalist], [])
		.map(finalist => ({
			name: getFinalistNamesByArea(finalist.area),
			link: props.linkToSenate + `#/obvod/${finalist.area.id}`
		}));

	const allItems = getAllItems(getSenateItems());

	return (
		<Panel>
			<Label>Průběh sčítání:</Label>
			<Marquee>
				{allItems.map((item, index) => (
					<>
						{item.link ?
							<>
								<a className={link} key={index} href={item.link}>
									{item.name}
								</a>
								<span>.</span>
							</>
							:
							<span key={index}>
								{item.name}
							</span>
						}
					</>
				))}
			</Marquee>
		</Panel>
	)
}
